// extracted by css-extract-rspack-plugin
module.exports =  {"doubleboder":"iKz8K","singleBorder":"xh07W","singleBorderSolid":"bg1ju","noBorder":"P2uS8","mobileGap":"qsmuE","defenceGap":"Xwkbd"};